"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORIFLAME_LOGO = void 0;
const ORIFLAME_LOGO = exports.ORIFLAME_LOGO = 'oriflame-logo';
